var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtonNextGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.337953 17.3544C-0.112651 16.9037 -0.112651 16.1732 0.337953 15.7226L7.21437 8.84615L0.337955 1.96974C-0.11265 1.51913 -0.11265 0.788558 0.337955 0.337954C0.78856 -0.112651 1.51913 -0.112651 1.96974 0.337954L9.66205 8.03026C9.87843 8.24665 10 8.54014 10 8.84615C10 9.15217 9.87843 9.44566 9.66205 9.66205L1.96974 17.3544C1.51913 17.805 0.788558 17.805 0.337953 17.3544Z",
    fill: "#363853"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonNextGrey);
export default __webpack_public_path__ + "static/media/button_next_grey.01991e24641c7a74964b0ed5117c4e4d.svg";
export { ForwardRef as ReactComponent };